import {
    GET_AAA_SERVER,
    GET_AAA_SERVER_SUCCESS,
    GET_AAA_SERVER_FAIL,
    AAA_SERVER_ADD_TRIGGER,
} from '../../constants/globalProfileConstants/aaaServerConstants';

/**
 * Reducer function for managing AAA Server list state.
 *
 * This reducer handles actions related to fetching AAA Server data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the AAA Server list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const aaaServerReducer = (state = { aaaServerList: {} }, action) => {
    switch (action.type) {
        case GET_AAA_SERVER:
            return {
                loading: true,
            };
        case GET_AAA_SERVER_SUCCESS:
            return {
                loading: false,
                aaaServerList: action.payload,
            };
        case GET_AAA_SERVER_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export const aaaServerTriggerReducer = (state = { aaaServerAddTrigger: false }, action) => {
    switch (action.type) {
        case AAA_SERVER_ADD_TRIGGER:
            return {
                ...state,
                aaaServerAddTrigger: action.payload,
            };
        default:
            return state;
    }
};
